export default __webpack_public_path__ + "static/media/liberum-9.1143ae15.png";